export interface SseFrame {
  /** The `event:` line, or `message` when a frame has none. */
  event: string;
  /** Every `data:` line joined — still a string; the caller parses it. */
  data: string;
}

/**
 * Splits whatever has arrived on an event stream into whole frames.
 *
 * SSE frames are separated by a blank line, and a network chunk can hold
 * several of them or half of one — so anything after the last separator is
 * handed back as `rest`, to be prepended to the next chunk.
 *
 * Shared by the two readers, `useLiveQuery` (a GET that updates a cache
 * entry) and the research room's question (a POST that streams its answer),
 * which differ in everything except the wire format.
 */
export function parseSseFrames(buffer: string): {
  frames: SseFrame[];
  rest: string;
} {
  const parts = buffer.split('\n\n');
  const rest = parts.pop() ?? '';

  const frames = parts.map((part) => {
    const lines = part.split('\n');
    const event =
      lines
        .find((line) => line.startsWith('event:'))
        ?.slice(6)
        .trim() ?? 'message';
    const data = lines
      .filter((line) => line.startsWith('data:'))
      .map((line) => line.slice(5).trim())
      .join('');
    return { data, event };
  });

  return { frames, rest };
}
